const baseStyle = {}

const defaultProps = {
  size: 'xl',
  variant: 'default',
}

const parts = ['container', 'icon', 'firstLevelItem', 'item', 'text']

const sizes = {
  xl: {
    item: {
      fontSize: 'md', // 16px
      height: 48,
      lineHeight: '24px',
      py: '12px',
    },
    icon: {
      height: 18,
      width: 18,
    },
  },
}

const variants = {
  default: {
    container: {
      bg: 'white',
    },
    firstLevelItem: {
      bg: 'white',
      color: 'seaBlue.main',
      activeColor: 'seaBlue.main',
      activeBg: 'skyBlue.85',
      hoverBg: 'skyBlue.80', // '#A6DEF2'
    },
    item: {
      bg: 'white',
      color: 'seaBlue.main',
      activeColor: 'seaBlue.main',
      activeBg: 'skyBlue.85',
      hoverBg: 'skyBlue.80',
      selectedBg: 'skyBlue.10',
      px: 2,
    },
  },
  dark: {
    container: {
      bg: 'darkBlue.main',
      color: 'white',
    },
    firstLevelItem: {
      bg: 'darkBlue.main',
      color: 'white',
      activeBg: 'darkBlue.25',
      activeColor: 'seaBlue.main',
      hoverBg: 'darkBlue.25', //'#152D6A'
      hoverColor: 'white',
    },
    item: {
      bg: 'skyBlue.97',
      color: 'seaBlue.main',
      activeBg: 'skyBlue.85',
      activeColor: 'seaBlue.main',
      hoverBg: 'skyBlue.80',
      hoverColor: 'seaBlue.main',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
